import {
  Box,
  Image,
  ButtonGroup,
  Container,
  Divider,
  IconButton,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react'
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa'
import { ButtonLink } from './navbar/ButtonLink'
import { FiExternalLink } from 'react-icons/fi';
import { TEMPLATE } from '@/shared/constants';

type Link = {
  label: string;
  href: string;
  title: string;
  target?: string;
};

type LinkGroup = {
  title: string;
  links: Link[];
};

const links: LinkGroup[] = [
  {
    title: 'EIT Label',
    links: [
      { label: 'About EIT Label', href: `/page/${TEMPLATE.PAGE_ABOUT}`, title: 'The EIT Label platform' },
      { label: 'Contact', href: 'mailto:support.eitlabel@eiturbanmobility.eu', title: 'Email us' },
    ],
  },
  {
    title: 'EIT Urban Mobility',
    links: [
      { label: 'Who We Are', href: 'https://www.eiturbanmobility.eu/', target: '_blank', title: 'EIT Urban Mobility website' },
      { label: 'Urban Mobility Explained', href: 'https://urbanmobilitycourses.eu/', target: '_blank', title: 'EIT Urban Mobility courses' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', href: 'https://www.eiturbanmobility.eu/privacy-policy/', target: '_blank', title: 'EIT Urban Mobility privacy policy' },
      { label: 'Cookie Policy', href: 'https://www.eiturbanmobility.eu/cookie-policy/', target: '_blank', title: 'EIT Urban Mobility cookie policy' },
    ],
  },
]

export const Footer = () => (
  <Box className="no-print" mt='2' bg="var(--chakra-colors-bg-subtle)">
    <Divider />
    <Container as="footer" role="contentinfo">
      <Stack
        justify="space-between"
        align="start"
        direction={{ base: 'column', lg: 'row' }}
        py={{ base: '4', md: '6' }}
        spacing="8"
      >
        <Stack spacing={{ base: '6', md: '8' }} align="start">
          <Image fill='fg.subtle' w={300} src="/logo_footer.svg" alt="EIT Picture" />
        </Stack>
        <SimpleGrid mt={{ base: '2', md: '6' }} columns={{ base: 2, md: 3 }} gap="8" width={{ base: 'full', lg: 'auto' }}>
          {links.map((group, idx) => (
            <Stack key={idx} spacing="4" minW={{ lg: '40' }}>
              <Text fontSize="md" fontWeight="semibold" color="gray.500">
                {group.title}
              </Text>
              <Stack spacing="3" shouldWrapChildren>
                {group.links.map((link, idx) => (
                  <ButtonLink title={link.title} rightIcon={link.target ? <FiExternalLink /> : undefined} key={idx} as="a" variant="text" colorScheme="gray" color='gray.600' to={link.href} target={link.target} >
                    {link.label}
                  </ButtonLink>
                ))}
              </Stack>
            </Stack>
          ))}
        </SimpleGrid>
      </Stack>
      <Divider />
      <Stack
        pt="2"
        pb="3"
        justify="space-between"
        direction={{ base: 'column-reverse', md: 'row' }}
        align="center"
      >
        <Text fontSize="sm" color="fg.subtle">
          &copy; {new Date().getFullYear()} EIT Urban Mobility. All rights reserved.
        </Text>
        <ButtonGroup variant="tertiary">
          <IconButton as="a" target='_blank' href="https://linkedin.com/company/eit-urban-mobility" aria-label="LinkedIn" icon={<FaLinkedin />} />
          <IconButton as="a" target='_blank' href="https://www.instagram.com/eiturbanmob/" aria-label="Instagram" icon={<FaInstagram />} />
          <IconButton as="a" target='_blank' href="https://www.facebook.com/pg/EIT-Urban-Mobility-1951333174955858/posts/" aria-label="Facebook" icon={<FaFacebook />} />
          <IconButton as="a" target='_blank' href="https://www.youtube.com/channel/UCnsVPKuZBK_UiZo0MOYNxXQ" aria-label="YouTube" icon={<FaYoutube />} />
        </ButtonGroup>
      </Stack>
    </Container>
  </Box>
)